import React from 'react';
import { Formik, Form as FormikForm } from 'formik';
import { useEntityForm } from '../../hooks/useEntityForm';
import { useDeleteHandler } from '../../hooks/useDeleteHandler';
import { EntityFormLayout } from '../../components/form/EntityFormLayout';
import { DynamicFormFields } from '../../components/form/DynamicFormFields';
import {
  roleFormFields,
  roleFormSchema, 
  roleConfig,
  roleFormInitialValues, 
} from './role.config';
import { CreateRoleRequest, Role, UpdateRoleRequest } from '../../types/roles.types';

const RoleForm: React.FC = () => {
  const {
    id, mode, data, loading, handleSubmit, handleReset, navigate,
  } = useEntityForm<Role, CreateRoleRequest, UpdateRoleRequest>({
    entityName: roleConfig.entityName,
    getEntity: roleConfig.api.getOne,
    createEntity: roleConfig.api.create,
    updateEntity: roleConfig.api.update,
    redirectPath: roleConfig.redirectPath,
  });

  const deleteHandler = useDeleteHandler();
  const handleDelete = () => id && deleteHandler({
    id,
    entityName: roleConfig.entityName,
    deleteApi: roleConfig.api.delete,
    redirectPath: roleConfig.redirectPath,
  });  
  return (
    <div className="h-full flex flex-col">
      <Formik
        key={`${id}-${mode}`}
        enableReinitialize
        initialValues={roleFormInitialValues(data)}
        validationSchema={roleFormSchema}
        onSubmit={handleSubmit}
      >
        {({ dirty }) => (
          <FormikForm className="flex flex-col flex-grow h-full">
            <EntityFormLayout
              title={
                mode === 'create'
                  ? `Create ${roleConfig.entityName}`
                  : mode === 'edit'
                    ? `Edit ${roleConfig.entityName}`
                    : `View ${roleConfig.entityName}`
              }
              mode={mode}
              data={data}
              loading={loading}
              dirty={dirty}
              onGoBack={() => navigate(roleConfig.redirectPath)}
              onReset={handleReset}
              onDelete={handleDelete}
              onCreateNew={() => navigate(`${roleConfig.redirectPath}/create`)}
              onEdit={() => navigate(`${roleConfig.redirectPath}/edit/${id}`)}
              onView={() => navigate(`${roleConfig.redirectPath}/view/${id}`)}
            >
              <DynamicFormFields fields={roleFormFields}  mode={mode} />
            </EntityFormLayout>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};

export default RoleForm;
